import { useCallback, useRef } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import Products from "../Products";

const Main = () => {
  const title = "Ofertas da Semana";
  const navigate = useNavigate();
  const location = useLocation();
  const handled = useRef(false);

  const autoRedirect = Boolean(
    (location.state as { autoRedirect?: boolean } | null)?.autoRedirect
  );

  // Após login/entrada na campanha solar, se as ofertas estiverem vazias,
  // leva o usuário ao catálogo. Navegação manual mantém a mensagem normal.
  const handleLoaded = useCallback(
    ({ count, isLoading }: { count: number; isLoading: boolean }) => {
      if (!autoRedirect || handled.current || isLoading) return;
      handled.current = true;
      if (count === 0) {
        navigate("/produtos", { replace: true });
      } else {
        // Limpa o state para o F5 não disparar o redirecionamento
        navigate("/", { replace: true, state: null });
      }
    },
    [autoRedirect, navigate]
  );

  return (
    <Products title={title} promocao params={{}} onLoaded={handleLoaded} />
  );
};

export default Main;
